import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RECEIVE_USER } from "../../reducer/user";
import axios from "axios";
import '../../style/main.css'
import { Layout } from "antd";

export default function Main() {
  const loginUser = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loginUser.username) {
      axios.get("/api/v1/user")
          .then((r) => r.data)
          .then((r) => {
            dispatch({
              type: RECEIVE_USER,
              user: r
            })
          })
    }
  },)

  return (
      <Layout.Content>
        <div className="welcome-container">
          <h1>환영합니다! {loginUser.username}님!</h1>
        </div>
      </Layout.Content>
  )
}